import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { Component } from 'react';
import { css } from 'emotion';
import { getLocalText } from '@/utilities/language';
import { inputChecker, getRealShowOption } from '@/utilities/quest';
var randomComp = function randomComp() {
  return Math.random() - 0.5;
};
function randomOptions(options) {
  var saveNoRandomOptions = [];
  for (var i = options.length - 1; i >= 0; i--) {
    var option = options[i];
    if (option.noRandom) {
      saveNoRandomOptions.push([option, i]);
      options.splice(i, 1);
    }
  }
  var result = options.slice().sort(randomComp);
  while (saveNoRandomOptions.length) {
    var _saveNoRandomOptions$ = saveNoRandomOptions.pop(),
      _saveNoRandomOptions$2 = _slicedToArray(_saveNoRandomOptions$, 2),
      _option = _saveNoRandomOptions$2[0],
      index = _saveNoRandomOptions$2[1];
    result.splice(index, 0, _option);
  }
  return result;
}
function getTotalPersent(options, option_blank) {
  if (options.length && option_blank && Object.keys(option_blank).length) {
    var total = 0;
    var ids = options.map(function (item) {
      return item.id;
    });
    Object.keys(option_blank).forEach(function (key) {
      if (ids.includes(key)) {
        var numArr = option_blank[key];
        if (numArr && numArr.length && Number(numArr[0]) !== NaN) {
          total = total + Number(numArr[0]);
        }
      }
    });
    return total;
  }
  return 0;
}
var OptionInput = /*#__PURE__*/function (_Component) {
  _inherits(OptionInput, _Component);
  function OptionInput(props) {
    var _this;
    _classCallCheck(this, OptionInput);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(OptionInput).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setInput", function (ids) {
      var _this$props = _this.props,
        question = _this$props.question,
        answer = _this$props.answer;
      var getFieldProps = _this.props.form.getFieldProps;
      var _getFieldProps = getFieldProps(question.id, {
          initialValue: answer,
          rules: [{
            required: true,
            validator: _this.validator
          }]
        }),
        onChange = _getFieldProps.onChange,
        formAnswer = _getFieldProps.value;
      var option_blank = formAnswer.option_blank;
      if (option_blank && Object.keys(option_blank).length) {
        Object.keys(option_blank).forEach(function (key) {
          if (!ids.includes(key)) {
            onChange(_this.getInputChange(key, '', formAnswer));
          }
        });
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "validator", function (rules, answer, callback) {
      var realShowOptions = _this.state.realShowOptions;
      var option_blank = answer.option_blank;
      var _this$props2 = _this.props,
        question = _this$props2.question,
        required = _this$props2.question.required;
      var restrictions = (window.showMultiLang ? question === null || question === void 0 ? void 0 : question["".concat(window.language, "Restrictions")] : question === null || question === void 0 ? void 0 : question.restrictions) || {};
      if (required) {
        if (!option_blank || option_blank && Object.keys(option_blank).length === 0) {
          callback(getLocalText('SingleChoice.Selected')); // '请填写答案');
          return;
        }
        realShowOptions.forEach(function (option) {
          if (!option_blank[option.id] || option_blank[option.id].length === 0 || option_blank[option.id][0] === '') {
            callback(getLocalText('SingleChoice.Selected')); // '请填写答案');
          }
        });

        if ((restrictions === null || restrictions === void 0 ? void 0 : restrictions.contentType) === 'percent') {
          var total = getTotalPersent(realShowOptions, answer.option_blank);
          if (total !== (restrictions === null || restrictions === void 0 ? void 0 : restrictions.specificGravity)) {
            callback(getLocalText('optionInput.specificGravity')); // '请调整比重');
            return;
          }
        }
      }
      _this.checkRestrictions(answer, restrictions, callback);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "checkRestrictions", function (answer, restrictions, callback) {
      if (answer.text && restrictions) {
        var checkResult = inputChecker(answer.text, restrictions);
        if (checkResult !== true) {
          callback(checkResult);
          return;
        }
      }
      // console.log(
      //   getTotalPersent(realShowOptions, formAnswer.option_blank),
      //   'getTotalPersent'
      // );
      callback();
    });
    var _question = props.question,
      answers = props.answers;
    var _realShowOptions = getRealShowOption({
      question: _question,
      answers: answers
    });
    _this.state = {
      realShowOptions: _realShowOptions
    };
    return _this;
  }
  _createClass(OptionInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var prevQ = prevProps.question;
      var nextQ = this.props.question;

      // 如果选项变了 就改变答案
      if (prevState.realShowOptions.length > this.state.realShowOptions.length) {
        this.setInput(this.state.realShowOptions.map(function (el) {
          return el.id;
        }));
      }
      // 预览模式下面始终不成立（broadcastchannel 使用JSON.stringify传递数据
      // 问卷模式下面始终成立， 问卷结构不会改变
      if (prevQ === nextQ) return;
      // 打开随机按钮
      if (!prevQ.custom.random && nextQ.custom.random) {
        // eslint-disable-next-line
        this.setState({
          realShowOptions: randomOptions(_toConsumableArray(nextQ.custom.options))
        });
      }
      // 关闭随机按钮
      if (prevQ.custom.random && !nextQ.custom.random) {
        // eslint-disable-next-line
        this.setState({
          realShowOptions: nextQ.custom.options
        });
      }
      // 判断是否修改了options， 但是broadcastchannell始终是深拷贝传递。所以这里不能比较地址了。
      if (JSON.stringify(nextQ.custom.options) !== JSON.stringify(prevQ.custom.options)) {
        // eslint-disable-next-line
        if (nextQ.custom.random) this.setState({
          options: randomOptions(_toConsumableArray(nextQ.custom.options))
        });
        // eslint-disable-next-line
        else this.setState({
          realShowOptions: nextQ.custom.options
        });
      }
    }
  }, {
    key: "getInputChange",
    value: function getInputChange(id, input, answer) {
      var text = answer && answer.text || '';
      var selected = (answer.selected || []).slice();
      if (!selected.includes(id)) selected.push(id);
      var value = input;
      var question = this.props.question;
      var restrictions = (window.showMultiLang ? question === null || question === void 0 ? void 0 : question["".concat(window.language, "Restrictions")] : question === null || question === void 0 ? void 0 : question.restrictions) || {};
      var contentType = restrictions.contentType;
      if (contentType === 'number') {
        value = value.replace(/[^\-\d.]/g, '');
      } else if (contentType === 'percent') {
        value = value.replace(/[^\d]/g, '');
      }
      return {
        type: 'optionInput',
        text: text,
        selected: selected,
        option_blank: _objectSpread({}, answer.option_blank, _defineProperty({}, id, [value]))
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _question$custom,
        _this2 = this;
      var _this$props3 = this.props,
        question = _this$props3.question,
        answer = _this$props3.answer,
        _this$props3$device = _this$props3.device,
        device = _this$props3$device === void 0 ? 'pc' : _this$props3$device;
      var realShowOptions = this.state.realShowOptions;
      var restrictions = (window.showMultiLang ? question === null || question === void 0 ? void 0 : question["".concat(window.language, "Restrictions")] : question === null || question === void 0 ? void 0 : question.restrictions) || {};
      var _this$props$form = this.props.form,
        getFieldProps = _this$props$form.getFieldProps,
        getFieldError = _this$props$form.getFieldError;
      var id = question.id || 'unknown-form-item';
      var _question$custom$text = question.custom.text,
        text = _question$custom$text === void 0 ? '' : _question$custom$text;
      var placeholder = window.showMultiLang ? (_question$custom = question.custom) === null || _question$custom === void 0 ? void 0 : _question$custom["".concat(window.language, "Text")] : text;
      var openWordsRestriction = restrictions.openWordsRestriction,
        maxWords = restrictions.maxWords;
      var _getFieldProps2 = getFieldProps(id, {
          initialValue: answer,
          rules: [{
            required: true,
            validator: this.validator
          }]
        }),
        onChange = _getFieldProps2.onChange,
        formAnswer = _getFieldProps2.value;
      var error = getFieldError(id);
      if (error && error.length > 0) error = error.join(',');else error = null;
      var params = {
        options: realShowOptions,
        error: error,
        formAnswer: formAnswer,
        placeholder: placeholder,
        onChange: {
          input: function input(id, _input) {
            onChange(_this2.getInputChange(id, _input, formAnswer));
          }
        },
        maxWords: openWordsRestriction && maxWords
      };
      return React.createElement("div", {
        className: optionContCls
      }, this.props.children(params), restrictions && restrictions.contentType === 'number' && React.createElement("div", {
        className: "numTip",
        style: device === 'mobile' ? {
          bottom: 12,
          padding: '0 16px'
        } : {}
      }, "\u63D0\u793A\uFF1A\u672C\u9898\u586B\u5199\u5185\u5BB9\u53EA\u652F\u6301\u6570\u5B57"), restrictions && restrictions.contentType === 'percent' && React.createElement("div", {
        className: "numTip",
        style: device === 'mobile' ? {
          bottom: 14,
          padding: '0 16px'
        } : {}
      }, "\u63D0\u793A\uFF1A\u672C\u9898\u586B\u5199\u5185\u5BB9\u53EA\u652F\u6301\u6574\u6570", React.createElement("span", null, "\uFF0C\u603B\u6BD4\u91CD\u503C\u5FC5\u987B\u4E3A\uFF1A", React.createElement("strong", null, restrictions.specificGravity || 100)), "\xA0", React.createElement("span", null, "\uFF0C\u5DF2\u5206\u914D\u6BD4\u91CD\uFF1A", React.createElement("span", {
        style: {
          color: 'red'
        }
      }, getTotalPersent(realShowOptions, formAnswer.option_blank)))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      var question = nextProps.question,
        answers = nextProps.answers;
      var realShowOptions = getRealShowOption({
        question: question,
        answers: answers
      });
      window.allQuestions.find(function (el) {
        return el.id === question.id;
      }).custom.realShowOptions = realShowOptions;
      if (realShowOptions.length !== state.realShowOptions.length || realShowOptions.some(function (el) {
        return !state.realShowOptions.find(function (item) {
          return item.id === el.id;
        });
      }) || realShowOptions.some(function (el) {
        return el.text !== state.realShowOptions.find(function (item) {
          return item.id === el.id;
        }).text;
      })) {
        if (question.custom.random) {
          realShowOptions = randomOptions(realShowOptions);
        }
        return {
          realShowOptions: realShowOptions
        };
      }
      return null;
    }
  }]);
  return OptionInput;
}(Component);
_defineProperty(OptionInput, "defaultProps", {
  answer: {
    selected: [],
    text: '',
    type: 'optionInput'
  },
  device: 'pc'
});
export { OptionInput as default };
var optionContCls = /*#__PURE__*/css("position:relative;.numTip{position:absolute;bottom:20px;padding:0 56px;font-size:12px;color:gray;}");